import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: 'input[selectAllOnFocus]',
    standalone: false
})
export class SelectAllOnFocusDirective {

    constructor(
        private inputElementRef: ElementRef
    ) {}

    @HostListener('focus')
    public selectAllText(): void {
        const textLength: number = this.inputElementRef.nativeElement.value.length;

        this.inputElementRef.nativeElement
            .setSelectionRange(0, textLength); // "select all"
    }

}
